import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
    selector: 'app-energy-flow-line',
    templateUrl: './energy-flow-line.component.html',
    styleUrls: ['./energy-flow-line.component.scss'],
    standalone: false
})
export class EnergyFlowLineComponent implements OnChanges, OnInit {
  @Input() x1!: number;
  @Input() y1!: number;
  @Input() x2!: number;
  @Input() y2!: number;
  @Input() radius!: number;
  @Input() radiusPoint = 10;
  @Input() colorScale = 'grey';
  @Input() invert = false;
  @Input() flowLines: any[] = []

  path = '';
  pointX = 0;
  pointY = 0;

  ngOnInit(): void {

  }
  ngOnChanges(): void {
    this.calculatePath();
    // this.flowLines.forEach((line) => {
    //   if (line.colorScale === '#00778B')
    //   console.log('invert lines ', line);

    // })
  }


  calculatePath(): void {
    let x1 = this.x1;
    let y1 = this.y1;
    let x2 = this.x2;
    let y2 = this.y2;
    const r = this.radiusPoint;

    // Desplazar el punto de inicio según la dirección del flujo
    if (x2 > x1) x1 += this.radius;
    else if (x2 < x1) x1 -= this.radius;

    if (x2 === x1 && y2 !== y1) y1 += this.radius;

    if (y2 > y1) y2 -= 15;
    else if (y2 < y1) y2 += 20;

    // Casos horizontales o verticales (línea recta)
    if (x1 === x2 || y1 === y2) {
      this.path = `M ${x1} ${y1} L ${x2} ${y2}`;
      return;
    }

    // Curvas con segmento horizontal, curva y tramo final
    if (x2 > x1) {
      if (y2 < y1) {
        this.path = `M ${x1} ${y1} L ${x2 - r} ${y1} Q ${x2 - 5} ${y1} ${x2 - 5} ${y1 - r} L ${x2 - 5} ${y2}`;
      } else {
        this.path = `M ${x1} ${y1} L ${x2 - r} ${y1} Q ${x2 - 5} ${y1} ${x2 - 5} ${y1 + r} L ${x2 - 5} ${y2}`;
      }
    } else {
      if (y2 < y1) {
        this.path = `M ${x1} ${y1} L ${x2 + r} ${y1} Q ${x2 + 5} ${y1} ${x2 + 5} ${y1 - r} L ${x2 + 5} ${y2}`;
      } else {
        this.path = `M ${x1} ${y1} L ${x2 + r} ${y1} Q ${x2 + 5} ${y1} ${x2 + 5} ${y1 + r} L ${x2 + 5} ${y2}`;
      }
    }
  }


  getAnimatedPath(line: {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    radius?: number;
    radiusPoint?: number;
    invert?: boolean;
  }): string {
    const { x1, y1, x2, y2, radius = 40, radiusPoint = 20, invert = false } = line;

    // Ajustes según dirección
    let startX = x1;
    let startY = y1;
    let endX = x2;
    let endY = y2;

    if (endX > startX) startX += radius;
    else if (endX < startX) startX -= radius;

    if (endX === startX && endY !== startY) startY += radius;

    if (endY > startY) endY -= 15;
    else if (endY < startY) endY += 20;

    // Líneas rectas
    if (startX === endX || startY === endY) {
      return `M ${startX} ${startY} L ${endX} ${endY}`;
    }

    // Curvas
    if (endX > startX) {
      return endY < startY
        ? `M ${startX} ${startY} L ${endX - radiusPoint} ${startY} Q ${endX - 5} ${startY} ${endX - 5} ${startY - radiusPoint} L ${endX - 5} ${endY}`
        : `M ${startX} ${startY} L ${endX - radiusPoint} ${startY} Q ${endX - 5} ${startY} ${endX - 5} ${startY + radiusPoint} L ${endX - 5} ${endY}`;
    } else {
      return endY < startY
        ? `M ${startX} ${startY} L ${endX + radiusPoint} ${startY} Q ${endX + 5} ${startY} ${endX + 5} ${startY - radiusPoint} L ${endX + 5} ${endY}`
        : `M ${startX} ${startY} L ${endX + radiusPoint} ${startY} Q ${endX + 5} ${startY} ${endX + 5} ${startY + radiusPoint} L ${endX + 5} ${endY}`;
    }
  }


  isValidLine(line: any): boolean {
  return (
    line &&
    typeof line.x1 === 'number' &&
    typeof line.y1 === 'number' &&
    typeof line.x2 === 'number' &&
    typeof line.y2 === 'number' &&
    !isNaN(line.x1) &&
    !isNaN(line.y1) &&
    !isNaN(line.x2) &&
    !isNaN(line.y2)
  );
}

trackFlowLine(index: number, line: any) {
  return `${line.x1}_${line.y1}_${line.x2}_${line.y2}`;
}



}

